var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-not-found"},[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v(" "+_vm._s(_vm.$t("errror_not_found"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }